export const sortBonusesByAvailabilityAndAmount = (a, b) => {
  if (a.disabled !== b.disabled) {
    return (a.disabled ? 1 : 0) - (b.disabled ? 1 : 0);
  }

  return (b.financeData?.maxBonusAmount ?? 0) - (a.financeData?.maxBonusAmount ?? 0);
};
